import Api from './Api';


export default {
    GetRecipeReports(payload) {
        return Api().post('/api/admin/getRecipeReports', payload)
    },
    GetFastMovingReports(payload) {
        return Api().post('/api/admin/getFastMovingReports', payload)
    },
    GetCurrentStockReport(payload) {
        return Api().post('/api/admin/getCurrentStockReport', payload)
    },
    GetCOGSReport(payload) {
        return Api().post('/api/admin/getCOGSReport', payload)
    },
    GetDailyConcessionReport(payload) {
        if(payload && payload.hasOwnProperty('OLD') && payload.OLD)  {
            return Api().post('/api/admin/v2.1/getDailyConcessionReport', payload);
          } else {
            return Api().post('/api/admin/getDailyConcessionReport', payload)
          }
    },
    GetStockWastageReport(payload) {
        return Api().post('/api/admin/getStockWastageReport', payload)
    },
    GetFnbAnalyticsData(payload) {
        return Api().post('/api/admin/GetFnbAnalyticsData', payload)
    },
    GetDailyPerishableMovement(payload) {
        return Api().post('/api/admin/getDailyPerishableMovement', payload);
    }
}


// WEBPACK FOOTER //
// ./src/services/FnBReportsService.js